import { AdobeAudienceManager } from '@/lib/ads/components/adobe-audience-manager'
import { AdSenseScripts } from '@/lib/ads/components/adsense/AdSenseScripts'
import { BlockthroughScripts } from '@/lib/ads/components/blockthrough/BlockthroughScripts'
import { GptScripts } from '@/lib/ads/components/gpt/GptScripts'
import { PrebidScripts } from '@/lib/ads/components/prebid/PrebidScripts'
import { type srpGpt } from '@/lib/ads/types/adConfig'

import { AmazonTamScripts } from './components/amazon-tam/amazonTamScripts'

type AdvertisingScriptsProps = {
  gpt: srpGpt[]
}

export const AdvertisingScripts = ({ gpt }: AdvertisingScriptsProps) => {
  return (
    <>
      <GptScripts />

      <PrebidScripts />

      <AmazonTamScripts />

      <AdobeAudienceManager gpt={gpt} />

      <AdSenseScripts />

      <BlockthroughScripts />
    </>
  )
}
